<template>
  <h2 :class="textColor" class="text-xl sm:text-2xl xl:text-3xl leading-none font-semibold mb-5">
    {{ title }}
  </h2>
</template>

<script setup lang="ts">
defineProps({
  title: { type: String, required: false, default: undefined },
  textColor: { type: String, required: false, default: 'text-app-primary-1-red--torch' },
})
</script>
